import React, {Component} from "react"
import PropTypes from "prop-types"
import MaskedInput from 'react-text-mask'
import _ from 'lodash'

export default class NRTCepInput extends Component {

    componentDidMount() {
        this.input = React.createRef()
    }

    focus() {
        const input = _.get(this.input , 'current.inputElement')

        if (input )
            input.focus()

    }


    handleChange = (evt) => {
        this.props.onChange(evt.target.value)
    }


    render() {

        const num = /[0-9]/

        return (
            <div className={'nrt-form-input'}>

                <MaskedInput
                    mask={[num, num, num, num, num, '-', num, num, num]}
                    ref={this.input}
                    {...this.props}
                    onChange={this.handleChange}
                />
            </div>
        )
    }
}

NRTCepInput.propTypes = {
    onChange: PropTypes.func,
}

NRTCepInput.defaultProps = {}



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/CEPInput/index.js